import * as React from 'react';
import * as styles from './TourSection.css';

export const TourSection: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>{children}</div>
    </div>
  );
};
